// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHero_videoContainer__R-aMW","videoPlayer":"VideoHero_videoPlayer__9OaTh","content":"VideoHero_content__0Jl6c"};